import { useState } from 'react';
import { useIntl } from 'react-intl';

import {
  CommonLayout,
  NavBar,
  headerNavigation,
  MainTabView,
} from '@marketplace/common';
import { Logo } from '@marketplace/ui-elements';
import { ROUTE_DEVELOPER_DASHBOARD_MY_PROFILE } from '@developer/constants';

import { PersonalProfileForm, PartnerProfileForm ,ClientCredentialsForm } from './components';

import { useHeaderMenu } from '../shared';

import classes from './personal-page.module.scss';
import { New_footer as SimpleFooter } from '../../pages/layouts/landing-layout/footer/footer';

const Title = ({ text }: { text: string }) => {
  return <span className={classes.title}>{text}</span>;
};

export const PersonalPage = () => {
  const { formatMessage } = useIntl();
  const [activeIndexTab, setActiveIndexTab] = useState<number>(0);
  const rightHeaderSection = useHeaderMenu({
    profileUrl: ROUTE_DEVELOPER_DASHBOARD_MY_PROFILE,
    iconClassName: classes.menu_icon,
  });

  const tabsContent = [
    {
      title: formatMessage({ id: 'developer_personal_page_personal_profile' }),
      content: <PersonalProfileForm />,
    },
    {
      title: formatMessage({ id: 'developer_personal_page_partner_profile' }),
      content: <PartnerProfileForm />,
    },
    {
      title: formatMessage({ id: 'developer_personal_page_client_credentials' }),
      content: <ClientCredentialsForm />,
    },
  ];

  return (
    <div>
      <CommonLayout
      leftSection={
        <Title
          text={formatMessage({ id: 'developer_personal_page_my_account' })}
        />
      }
      logo={
        <Logo
          subLogo={formatMessage({ id: 'developer_personal_page_sub_logo' })}
        />
      }
      leftHeaderSection={<NavBar options={headerNavigation} />}
      rightHeaderSection={rightHeaderSection}
    >
      <MainTabView
        className={classes.root}
        tabsContent={tabsContent}
        activeIndex={activeIndexTab}
        setActiveIndex={setActiveIndexTab}
      />
    </CommonLayout>
    <div className={classes.registrationFooter}>
      <SimpleFooter/>
    </div>
    </div>
  );
};
